import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setPageTitle } from "../../../app/features/DataSlice";
import HeliorPlanList from "../../../components/HeliorPlan/HeliorPlanList";

const HePlan = () => {
  const pageTitle = "X-PLAN";
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle(pageTitle));
  });

  return (
    <div className="my-3">
      <HeliorPlanList pageTitle={pageTitle} />
    </div>
  );
};

export default HePlan;
